import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  headers = new HttpHeaders();

  constructor(private readonly http: HttpClient) { }

  /**
     * 
     * Envia el token a traves del cual se recuperan los datos para borrar el perfil
     * 
     */
  deleteProfile(): Observable<any> {
    return this.http.get<any>(environment.url + '/User/DeleteUser', { headers: this.headers.set('Authorization', sessionStorage.getItem('t')) })
      .pipe(retry(0), catchError(this.errorHandl));
  }

  /**
   * 
   * @returns Observable
   */
  getDataForm = (): Observable<any> => {
    return this.http.get<any>(environment.url + '/User/GetUserData', { headers: this.headers.set('Authorization', sessionStorage.getItem('t')) })
      .pipe(retry(0), catchError(this.errorHandl));
  }

  /**
   * guarda los datos del perfil
   * @param data: string
   */
  saveProfile = (d): Observable<any> => {
    return this.http.post(environment.url + '/User/UpdateUser', d, { headers: this.headers.set('Authorization', sessionStorage.getItem('t')) })
      .pipe(retry(0), catchError(this.errorHandl));
  }

  /**
   * guarda los datos del perfil
   * @param data: string
   */
  savePValue = (d, captcha): Observable<any> => {
    return this.http.post(environment.url + '/User/ChangePValue', d, { 
      headers: this.headers.set('Authorization', sessionStorage.getItem('t')
      ).set('recaptchaR', captcha)
    })
      .pipe(retry(0), catchError(this.errorHandl));
  }

  /**
   * Control errores generico para todas las llamadas
   * @param error: Object
   */
  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
